import React from 'react';
import {  Routes, Route } from 'react-router-dom';
import {
  ChakraProvider,
  Box,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';
import customTheme from "./utils/themes";
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Investments from './pages/Investments'
import Contact from './pages/Contact'
import IdahoFallsPortfolio from './pages/Listings/idaho-falls-portfolio-private-active'
import RexburgPortfolio from './pages/Listings/RexburgPortfolio';
import RexburgHousingPortfolio from './pages/Listings/RexburgHousingPortfolio';
import AlpineFlats from './pages/Listings/alpine-flats';
import ClosedFallsAtCanyonRim from './pages/Listings/closed-falls-at-canyon-rim';
import ParkStation from './pages/Listings/closed-park-station';
import CanyonPark from './pages/Listings/closed-canyon-park';
import TuscanyCove from './pages/Listings/closed-tuscany-cove';
import LakesideVillage from './pages/Listings/closed-lakeside-village';
import IvyAtDraper from './pages/Listings/closed-the-ivy-at-draper';
import NorthUnion from './pages/Listings/closed-north-union';
import HiddenVillas from './pages/Listings/hidden-villas';
import MurrayParkView from './pages/Listings/closed-murray-park-view';
import ModaSpringsRun from './pages/Listings/closed-moda-spring-run';
import VillasAtFernCircle from './pages/Listings/closed-villas-at-fern-circle';
import ClosedCrossroadApartments from './pages/Listings/closed-crossroads-apartments'
import ClosedEaglesLanding from './pages/Listings/closed-eagles-landing';
import ClosedRemingtonApartments from './pages/Listings/closed-remington-apartments';
import DesertSageTownhomes from './pages/Listings/desert-sage-townhomes';
import ShulsenLane from './pages/Listings/closed-shulsen-lane';
import TheLinq from './pages/Listings/the-linq';
import Ashli from './pages/Listings/ashli';
import LoftsOn34 from './pages/Listings/lofts-on-34';
import ClosedRevive from './pages/Listings/closed-revive';
import AtHome from './pages/Listings/at-home-rexburg';
import ClosedMonaco from './pages/Listings/closed-monaco';
import CollegeWay from './pages/Listings/college-way';
import ProvoPortfolio from './pages/Listings/provo-portfolio';
import ClosedGrandPortfolio from './pages/Listings/closed-the-grand';
import ClosedTwinPines from './pages/Listings/closed-twin-pines';
import ClosedSecondAvenue from './pages/Listings/closed-second-avenue';
//import BurnettPortfolio from './pages/Listings/burnett-portfolio';
import ClosedDixieCove from './pages/Listings/closed-dixie-cove';
import ClosedCreekview from './pages/Listings/closed-creekview';
import WeberHeights from './pages/Listings/weber-heights';
import Stadium from './pages/Listings/stadium';
import UBApartments from './pages/Listings/ub-apartments';
import ClosedWindsor from './pages/Listings/closed-windsor';
import ClosedConnieJean from './pages/Listings/closed-connie-jean';
import ClosedDouglasSt from './pages/Listings/closed-douglas-st';
import ClosedPointePortfolio from './pages/Listings/closed-pointe-portfolio';
import ClosedTalus from './pages/Listings/closed-talus';
import ClosedPrelude from './pages/Listings/closed-prelude';
import ClosedQuincy from './pages/Listings/closed-quincy';
import ClosedNevadaCircle from './pages/Listings/closed-nevada-circle';
import RaintreeCommons from './pages/Listings/raintree-commons';
import ClosedSouthSaltLakePortfolio from './pages/Listings/closed-south-salt-lake-portfolio';
import LoganLand from './pages/Listings/logan-land';
import TheYard from './pages/Listings/the-yard';
function App() {

  const location = useLocation();
  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);

  return (
    <ChakraProvider theme={customTheme}>
      <Box textAlign="center" fontSize="xl" bgColor={'#dfdfdf'}>

        <ScrollToTop/>
      <Routes>
        {/* Define the routes for each page */}
        <Route index element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/investments" element={<Investments />} />
        <Route path="/contact" element={<Contact />} />
        {/* Active Listing - Institutional */}
        
        <Route path="/rexburg-portfolio" element={<RexburgPortfolio />} />
        <Route path="/rexburg-housing-portfolio" element={<RexburgHousingPortfolio />} />
        {/* <Route path="/brookfield-apartments" element={<Brookfield />} /> */}
        {/* Active Listing - Private */}
        <Route path="/the-yard" element={<TheYard />} />
        <Route path="/logan-land" element={<LoganLand />} />
        <Route path="/raintree-commons" element={<RaintreeCommons />} />
        <Route path="/university-barbershop-apartments" element={<UBApartments />} />

        <Route path="/stadium150" element={<Stadium />} />
        <Route path="/weber-heights-apartments" element={<WeberHeights />} />
        <Route path="/provo-portfolio" element={<ProvoPortfolio />} />
        <Route path="/college-way-stadium-way" element={<CollegeWay />} />
        <Route path="/at-home-rexburg" element={<AtHome />} />
        <Route path="/lofts-on-34th" element={<LoftsOn34 />} />
        <Route path="/the-ashli-portfolio" element={<Ashli />} />
        <Route path="/the-linq" element={<TheLinq />} />
        <Route path="/desert-sage-townhomes" element={<DesertSageTownhomes />} />
        <Route path="/hidden-villas" element={<HiddenVillas />} />
        <Route path="/alpine-flats" element={<AlpineFlats />} />
        <Route path="/idaho-falls-portfolio" element={<IdahoFallsPortfolio />} />
        {/* Closed Listing */}
        <Route path="/closed-dixie-cove" element={<ClosedDixieCove />} />
        <Route path="/closed-windsor" element={<ClosedWindsor />} />
        <Route path="/closed-pointe-portfolio" element={<ClosedPointePortfolio />} />
        <Route path="/closed-nevada-circle" element={<ClosedNevadaCircle />} />
        <Route path="/closed-south-salt-lake-portfolio" element={<ClosedSouthSaltLakePortfolio />} />
        <Route path="/closed-Talus" element={<ClosedTalus />} />
        <Route path="/closed-prelude-at-paramount" element={<ClosedPrelude />} />
        <Route path="/closed-quincy-avenue" element={<ClosedQuincy />} />
        <Route path="/closed-100-s-554-douglas-st" element={<ClosedDouglasSt />} />
        <Route path="/closed-connie-jean" element={<ClosedConnieJean />} />
        <Route path="/closed-second-avenue" element={<ClosedSecondAvenue />} />
        <Route path="/closed-creekview" element={<ClosedCreekview />} />
        <Route path="/closed-twin-pines" element={<ClosedTwinPines />} />
        <Route path="/closed-the-grand-portfolio" element={<ClosedGrandPortfolio />} />
        <Route path="/closed-revive" element={<ClosedRevive />} />
        <Route path="/closed-remington-apartments" element={<ClosedRemingtonApartments />} />
        <Route path="/closed-shulsen-lane" element={<ShulsenLane />} />
        <Route path="/closed-eagles-landing" element={<ClosedEaglesLanding />} />
        <Route path="/closed-falls-at-canyon-rim" element={<ClosedFallsAtCanyonRim />} />
        <Route path="/closed-crossroads-apartments" element={<ClosedCrossroadApartments />} />
        <Route path="/closed-villas-at-fern-circle" element={<VillasAtFernCircle />} />
        <Route path="/closed-moda-spring-run" element={<ModaSpringsRun />} />
        <Route path="/closed-murray-park-view" element={<MurrayParkView />} />
        <Route path="/closed-park-station" element={<ParkStation />} />
        <Route path="/closed-canyon-park" element={<CanyonPark />} />
        <Route path="/closed-tuscany-cove" element={<TuscanyCove />} />
        <Route path="/closed-lakeside-village" element={<LakesideVillage />} />
        <Route path="/closed-ivy-at-draper" element={<IvyAtDraper />} />
        <Route path="/closed-north-union" element={<NorthUnion />} />
        <Route path="/closed-monaco" element={<ClosedMonaco />} />
        {/* Add a "Not Found" route in case the user visits an unknown URL */}
        <Route path="*" component={() => <div>Not Found</div>} />
      </Routes>

      </Box>
    </ChakraProvider>
  );
}

export default App;
